// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICipStatusBriefDto
 */
export interface ICipStatusBriefDto {
    /**
     * 
     * @type {Date}
     * @memberof ICipStatusBriefDto
     */
    date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICipStatusBriefDto
     */
    date_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICipStatusBriefDto
     */
    percent_passed?: string;
}

/**
 * Check if a given object implements the ICipStatusBriefDto interface.
 */
export function instanceOfICipStatusBriefDto(value: object): value is ICipStatusBriefDto {
    return true;
}

export function ICipStatusBriefDtoFromJSON(json: any): ICipStatusBriefDto {
    return ICipStatusBriefDtoFromJSONTyped(json, false);
}

export function ICipStatusBriefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipStatusBriefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date_from': json['date_from'] == null ? undefined : (new Date(json['date_from'])),
        'date_to': json['date_to'] == null ? undefined : (new Date(json['date_to'])),
        'percent_passed': json['percent_passed'] == null ? undefined : json['percent_passed'],
    };
}

export function ICipStatusBriefDtoToJSON(json: any): ICipStatusBriefDto {
    return ICipStatusBriefDtoToJSONTyped(json, false);
}

export function ICipStatusBriefDtoToJSONTyped(value?: ICipStatusBriefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date_from': value['date_from'] == null ? undefined : ((value['date_from']).toISOString().substring(0,10)),
        'date_to': value['date_to'] == null ? undefined : ((value['date_to']).toISOString().substring(0,10)),
        'percent_passed': value['percent_passed'],
    };
}

